import { useWebchatStore } from 'app/stores/WebchatStore';

export default function useWebchatVersion() {
  return useWebchatStore((state) => state.webchatVersion);
}
